import React from 'react';
import './card.css';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export function LinearDeterminate() {
	const [progress, setProgress] = React.useState(0);

	React.useEffect(() => {
		const timer = setInterval(() => {
			setProgress((oldProgress) => {
				if (oldProgress === 100) {
					return 0;
				}
				const diff = Math.random() * 10;
				return Math.min(oldProgress + diff, 100);
			});
		}, 500);

		return () => {
			clearInterval(timer);
		};
	}, []);

	return (
		<Box sx={{ width: '100%' }}>
			<LinearProgress variant='determinate' value={progress} />
		</Box>
	);
}

export interface ILoadingCardProps {
	title?: string;
	description?: string;
	progress?: number;
	viewMode?: 'grid' | 'rows';
}

const LoadingCard: React.FC<ILoadingCardProps> = (props: ILoadingCardProps) => {
	const shouldShowProgress = props.progress !== undefined;

	if (props.viewMode === 'rows') {
		return (
			<div className='gallery-row-card gallery-row-card--loading'>
				<div className='gallery-row-card-left' style={{ flexGrow: 1 }}>
					<div className='gallery-row-card-image bg-color-5 loading'></div>
					<div className='gallery-row-card-info' style={{ flexGrow: 1 }}>
						<h3 className='gallery-row-card-title loading' style={{ width: '40%', height: '14px' }}>
							{props.title}
						</h3>
						<p className='gallery-row-card-description loading' style={{ width: '80%', height: '10px', marginTop: '6px' }}>
							{props.description}
						</p>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className='loading_card'>
			<div className='loading_card__image'></div>
			{shouldShowProgress && <LinearDeterminate />}
			<div className='loading_card__content'>
				<h3
					className={`card-title truncated-title${
						!!props.title ? '' : ' loading'
					}`}
				>
					{props.title}
				</h3>
				<p
					className={`card-description${!!props.description ? '' : ' loading'}`}
				>
					{props.description}
				</p>
			</div>
		</div>
	);
};

export default LoadingCard;
